/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'system-settings-access-config-container';
const prefix = `${moduleName}.${componentName}`;

export const legacySslSupportHeader = `${prefix}.legacySslSupportHeader`;
export const enablePortalLegacySupportLabel = `${prefix}.enablePortalLegacySupportLabel`;
export const enableSystemLegacySupportLabel = `${prefix}.enableSystemLegacySupportLabel`;

export const ENGLISH = {
    [legacySslSupportHeader]: 'TLS 1.0/1.1 Support for SSL/TLS connections with Controller',
    [enablePortalLegacySupportLabel]: 'Enable Inbound Connections',
    [enableSystemLegacySupportLabel]: 'Enable Outbound Connections',
};
